import { Injectable } from '@angular/core';

import { authCodeFlowConfig } from '../../../config/identity-server.config';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private fullUrl: string = '';
  constructor(private oauthService: OAuthService) {
    this.oauthService.configure(authCodeFlowConfig);
  }

  public isAuthenticated(): boolean {
    if (this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken()) {
      return true;
    } else {
      return false;
    }
  }

  public login() {
    this.oauthService.loadDiscoveryDocumentAndLogin();
    /**
     * add а custom query param that not exist in AuthConfig model
     */
    this.oauthService.customQueryParams = {
      response_mode: 'query',
    };
  }

  public logout() {
    this.oauthService.logOut();
  }

  public getFullname(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.name) {
      return claims.name;
    }
    return '';
  }

  public getFirstName(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.given_name) {
      return claims.given_name;
    }
    return '';
  }

  public getLastName(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.family_name) {
      return claims.family_name;
    }
    return '';
  }

  public getEmail(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.email) {
      return claims.email;
    }
    return '';
  }

  public getPhoneCode(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.phoneCode) {
      return claims.phoneCode;
    }
    return '';
  }

  public getPhoneNumber(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.phoneNumber) {
      return claims.phoneNumber;
    }
    return '';
  }

  setFullUrl(url: string) {
    this.fullUrl = url;
  }

  getFullUrl(): string {
    return this.fullUrl;
  }

  public getProfileImg(): string {
    let claims: any = this.oauthService.getIdentityClaims();
    if (claims && claims.picture) {
      return claims.picture;
    }
    return '';
  }

  public getIdentifier(): string {
    let claims: any = this.oauthService.getIdentityClaims();

    if (claims && claims.given_name && claims.family_name) {
      let identifier = claims.given_name.substring(0, 1) + claims.family_name.substring(0, 1);
      return identifier;
    }
    return '';
  }
}
